import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { familyCreatorPausePath, familyCreatorStagePath, newAccountPath } from "@travily/routes";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { FamilyPrivacyStepView } from "./show.view";

interface PageProps {
  stage_index: number;
  total_stages: number;
  stage_order: string[];
  visibility: "public" | "private" | "hidden";
}

type PrivacyChoice = "public" | "private";

type FormData = {
  visibility: PrivacyChoice;
};

const FamilyPrivacyStep = ({ stage_index, stage_order, visibility }: PageProps) => {
  const initial: PrivacyChoice = visibility === "private" ? "private" : "public";

  const { form, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } = useWizardForm<FormData>({
    routes: {
      stageUrl: (stage) => familyCreatorStagePath(stage),
      entryUrl: newAccountPath(),
      pauseUrl: familyCreatorPausePath(),
    },
    stageName: "privacy",
    stageIndex: stage_index,
    stageOrder: stage_order,
    initialData: { visibility: initial },
  });

  const topBarActions = useCreatorTopBarActions({ onPause });

  return (
    <>
      <Head title={t("web.families.creator.steps.privacy.show.meta_title")}>
        <meta name="description" content={t("web.families.creator.steps.privacy.show.meta_description")} />
      </Head>
      <FamilyPrivacyStepView
        currentStage={currentStage}
        totalStages={totalStages}
        value={form.data.visibility}
        primaryPending={primaryPending}
        topBarActions={topBarActions}
        onBack={onBack}
        onPrimary={onPrimary}
        onChange={(value: string) => form.setData("visibility", value as PrivacyChoice)}
      />
    </>
  );
};

export default FamilyPrivacyStep;
